import { camelizeKeys } from 'humps';
import { get, post } from '@namespace/helpers';
import { IApiResponse } from '../../../types';

export interface ISuggesterGamesDataV1 {
  gameIds: string[];
}

export interface ISuggesterGamesData {
  internal_game_ids: string[];
}

export interface IColdHotListGames {
  game_id: number;
  rtp: string;
  arrow_up: boolean;
}

type ColdHotListGamesType = 'mixed' | 'cold' | 'hot';

export type ColdHotListGamesDataType = {
  [key in ColdHotListGamesType]: IColdHotListGames[];
};

export const getRecentlyPlayedGames = (
  type: string
): Promise<IApiResponse<ISuggesterGamesData>> =>
  post(
    `/service/suggester-games/suggester/v3/recently-played-games/get-games`,
    {
      game_list: type
    }
  );

export const getRecommendedGames = (
  type: string
): Promise<IApiResponse<ISuggesterGamesData>> =>
  post(`/service/suggester-games/suggester/v3/recommended-games/get-games`, {
    game_list: type
  });

export const getWagerSlotGames = (): Promise<
  IApiResponse<ISuggesterGamesDataV1>
> => get(`/service/suggester-games/suggester/v1/wager-slot-list/get`);

export const getLiveRtpGames = () =>
  get<IApiResponse<ColdHotListGamesDataType>>(
    `/service/suggester-games/suggester/v1/cold-hot-list`
  ).then((response) =>
    camelizeKeys<IApiResponse<ColdHotListGamesDataType>>(response)
  );
